import { ApolloClient, InMemoryCache, NormalizedCacheObject } from '@apollo/client';

import { DEV } from 'application/consts';

import { AuthCurrentUserDocument } from '@shared/api/graphql/generated';

export const ensureNormalizedCacheObjectClient = (client: ApolloClient<any>): ApolloClient<NormalizedCacheObject> => {
  if (client.cache instanceof InMemoryCache) {
    return client as ApolloClient<NormalizedCacheObject>;
  }

  if (DEV) {
    console.warn('ApolloClient cache is not InMemoryCache, but NormalizedCacheObject is expected');
  }

  return client as unknown as ApolloClient<NormalizedCacheObject>;
};

export const hasUserDataInCache = (client: ApolloClient<NormalizedCacheObject>): boolean => {
  try {
    const result = client.readQuery({
      query: AuthCurrentUserDocument,
    });

    return !!result?.currentUserPureQuery;
  } catch {
    return false;
  }
};

export const waitForUserDataInCache = (
  client: ApolloClient<NormalizedCacheObject>,
  timeout = 10000
): Promise<boolean> =>
  new Promise((resolve) => {
    if (hasUserDataInCache(client)) {
      resolve(true);

      return;
    }

    const startTime = Date.now();

    const interval = setInterval(() => {
      if (hasUserDataInCache(client)) {
        clearInterval(interval);
        resolve(true);
      } else if (Date.now() - startTime > timeout) {
        clearInterval(interval);

        console.warn('Timeout waiting for user data in Apollo cache');

        resolve(false);
      }
    }, 100);
  });
